import React from 'react';
import Icon from '../components/Icon';

const PricingPage: React.FC = () => {

  const features = [
    'إنشاء بواسطة الذكاء الاصطناعي',
    '20+ قالب قانوني',
    'دعم اللغتين العربية والإنجليزية',
    'تصدير المحتوى بسهولة',
    'تخزين بياناتك محلياً',
    'دعم فني عبر البريد الإلكتروني'
  ];

  return (
    <div className="px-4 sm:px-6 lg:px-[70px] py-16">
      <header className="text-center mb-12">
        <h1 className="text-4xl font-extrabold text-[var(--color-text-heading)]">أسعارنا</h1>
        <p className="mt-4 text-lg text-[var(--color-text-body)] max-w-2xl mx-auto">
          اختر الخطة التي تناسب احتياجاتك وابدأ في إنشاء مستنداتك القانونية اليوم.
        </p>
      </header>
      
      <div className="flex flex-col lg:flex-row justify-center items-center lg:items-stretch gap-8">
        {/* Free Plan */}
        <div className="bg-[var(--color-surface)] rounded-xl shadow-lg border border-[var(--color-border)] p-8 w-full max-w-md flex flex-col">
          <h2 className="text-2xl font-bold text-[var(--color-text-heading)]">الخطة المجانية</h2>
          <p className="text-[var(--color-text-body)] mt-2">مثالية للبدايات والتجارب</p>
          <div className="my-8">
            <span className="text-5xl font-extrabold text-[var(--color-text-heading)]">0</span>
            <span className="text-xl font-medium text-[var(--color-text-body)]"> ريال/شهرياً</span>
          </div>
          <p className="text-lg font-semibold text-[var(--color-primary)] mb-6">5 مستندات شهرياً</p>
          <a href="#" className="w-full text-center bg-transparent border border-[var(--color-border)] text-[var(--color-text-heading)] font-semibold py-3 px-4 rounded-lg hover:bg-[var(--color-border)] transition-colors">
            ابدأ الآن مجاناً
          </a>
          <ul className="mt-8 space-y-4 text-[var(--color-text-body)]">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <Icon name="Check" className="w-5 h-5 text-[var(--color-success)] mt-1 flex-shrink-0" />
                <span className="mr-3">{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Pro Plan */}
        <div className="relative bg-[var(--color-surface)] rounded-xl shadow-2xl border-2 border-[var(--color-primary)] p-8 w-full max-w-md flex flex-col transform lg:scale-105">
          <div className="absolute top-0 right-0 -mt-4 mr-4">
            <span className="bg-[var(--color-primary)] text-[var(--color-white)] text-xs font-bold px-3 py-1 rounded-full uppercase">الأكثر شعبية</span>
          </div>
          <h2 className="text-2xl font-bold text-[var(--color-primary)]">الخطة الاحترافية</h2>
          <p className="text-[var(--color-text-body)] mt-2">للاستخدام المكثف والميزات الكاملة</p>
          <div className="my-8">
            <span className="text-5xl font-extrabold text-[var(--color-text-heading)]">49</span>
            <span className="text-xl font-medium text-[var(--color-text-body)]"> ريال/شهرياً</span>
          </div>
          <p className="text-lg font-semibold text-[var(--color-primary)] mb-6">عدد غير محدود من المستندات</p>
          <a href="#" className="w-full text-center bg-[var(--color-primary)] text-[var(--color-white)] font-semibold py-3 px-4 rounded-lg hover:bg-[var(--color-primary-hover)] transition-colors">
            اشترك الآن
          </a>
          <ul className="mt-8 space-y-4 text-[var(--color-text-body)]">
             {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <Icon name="Check" className="w-5 h-5 text-[var(--color-success)] mt-1 flex-shrink-0" />
                <span className="mr-3">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
